import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  postEventsFailure,
  postEventsSuccess,
} from "../slices/features/postEvents";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* postEventSaga(action: any) {
  const { payload } = action;
  const { id, data } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.postEvents,
      baseUrl,
      id,
      data
    );

    yield put(postEventsSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(postEventsFailure({ statusCode, statusText }));
  }
}

export function* watchPostEvents() {
  yield takeLatest(RequestTypes.POST_EVENT_REQUEST, postEventSaga);
}
